export default "__VITE_ASSET__c6386021__"